import { CarregaService } from '../services/carrega_file/carrega.service';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { format, parse, differenceInDays } from 'date-fns';
import { ApiService } from '../services/contratos/contratos.service';
import { map, take } from 'rxjs/operators';
import { formatDate } from '@angular/common';
import { firstValueFrom, Observable } from 'rxjs';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-fluxo-aereo',
  standalone: false,
  templateUrl: './fluxo-aereo.component.html',
  styleUrls: ['./fluxo-aereo.component.css'],
  template: `
    <progressbar [value]="progressValue" [max]="100">{{ progressValue }}%</progressbar>
  `,
})
export class FluxoAereoComponent {
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  progressValue = 0; // Valor atual da barra de progresso
  maxValue = 0; // Valor máximo da barra de progresso
  showProgressBar = false;
  @ViewChild('downloadLink') downloadLink!: ElementRef<HTMLAnchorElement>;
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  query: string = 'items_Excel_Karrara';
  items$: Observable<any> | undefined;
  dataLoaded = false;
  jsonData: any;
  sortColumn: string = '';
  sortDirection: number = 1;
  dias_terminal: Date = new Date();
  Freetime: number = 0;
  dados: any[] = [];
  contratos: string[] = [];
  freetime: string[] = [];
  tripcost: string[] = [];
  custoViagem: string = "";
  handling: string[] = [];
  manuseio: string = "";
  demurrage: string[] = [];
  estadia: string = "";
  valorFree: string = '';
  liner: string = "";
  vessel: string = "";
  custoestadia: number = 0;
  isLoading: boolean = true;
  query3: string = 'tipos_Veiculos_Karrara';
  urlConsultaCompleta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  veiculos!: any[];

  constructor(
    private carregaService: CarregaService,
    private http: HttpClient,
    private dynamodbService: ApiService,
  ) { }

  async onFileSelected(event: any) {
    const file: File = event.target.files[0];
    const fileUrl = URL.createObjectURL(file);
    const fileBlob = await fetch(fileUrl).then(response => response.blob());
    const rawData = await this.carregaService.loadFile(fileBlob);
    const inflatedData = await this.inflateData(rawData); // Inflar os campos desejados
    this.jsonData = inflatedData;
    this.dataLoaded = true;
    // //console.log("jsonData")
    // console.log(this.jsonData)    
    // Chama a função para salvar os dados no API Gateway
  }

  isValorValido(value: any): boolean {
    return value != '' && value != null && value != undefined && value != 0;
  }

  async salvarNoBanco(jsonData: any) {
    const currentDate = new Date().getTime();
    this.showProgressBar = true;
    // console.log('Item a ser salvo:', jsonData);
    this.progressValue = 0;
    this.maxValue = jsonData.length;
    const batchSize = 10; // Defina o tamanho máximo para cada lote
    const batches = this.chunkArray(jsonData, batchSize); // Fraciona o jsonData em lotes menores
    // //console.log(this.veiculos)
    // this.jsonData.forEach((item: any) => {
    //   return (
    //   item.created = currentDate.toString(),
    //   item.capacidadePeso = this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).peso : 0,
    //   item.capacidadeVolumetrica = this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).volume : 0,
    //   item.veiculoPerfil = this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).perfil : 'Não encontrado',
    //   item.emissao = this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).emissoes : 0,
    //   item.consumo = this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).consumo : 0,
    //   item.emissaoTotal = (item['Total Distance'] * item.emissao) / item.consumo,
    //   item.fillingRateMax = Math.max(item['Weight Loaded'], item.Cubage)
    // )})

    for (const batch of batches) {
      // Acrescentar o campo "lastupdate" com o valor da data de hoje
      const currentDate = new Date();
      const formattedDate = currentDate.getDate().toString().padStart(2, '0') +
        (currentDate.getMonth() + 1).toString().padStart(2, '0') +
        currentDate.getFullYear().toString();
      for (const item of batch) {
        item.lastupdate = formattedDate;
        // console.log(item)
      }

      this.dynamodbService.salvar(batch, this.query, this.urlAtualiza).subscribe({
        next: () => {
          console.log('Programação salva com sucesso.');
          this.progressValue = this.progressValue + batch.length;
          // //console.log('Resposta do salvamento:', response);
          if (this.fileInput) {
            this.fileInput.nativeElement.value = '';
          }
          this.jsonData = null;
          this.dataLoaded = false;
          this.showProgressBar = false;
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Erro ao salvar programação:', err);
          this.isLoading = false;
        }
      });
    }
  }

  //     async getLinersTrail(): Promise<void> {
  //   try {
  //     const data = await firstValueFrom(this.dynamodbService.getAllLiner());
  //     console.log(data)
  //     this.trips = data['content'];
  //     console.log(this.listaLiners)
  //   } catch (err) {
  //     console.error('Erro ao buscar dados da programação:', err);
  //   } finally {
  //     // console.log(this.containersProgramados)
  //   }
  // }


  chunkArray(array: any[], size: number): any[][] {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  }

  async ngOnInit() {
    await this.getVeiculosFromDynamoDB();
    this.isLoading = false;
  }

  excelSerialToDate(serial: number): string {
    // Excel base date: 1899-12-30 (porque Excel considera 1900-01-01 = 1)
    const base = new Date(1899, 11, 30);
    const result = new Date(base.getTime() + serial * 24 * 60 * 60 * 1000);
    let resultStr = result.toISOString()
    return resultStr;
  }

  excelToTime(value: number): string {
    const totalMinutes = Math.round(value * 24 * 60); // converte para minutos
    const horas = Math.floor(totalMinutes / 60);
    const minutos = totalMinutes % 60;
    return `${String(horas).padStart(2, "0")}:${String(minutos).padStart(2, "0")}`;
  }

  inflateData(rawData: any[]): any[] {
    const dataAtual = Date.now();
    // console.log(rawData)
    let i = 0;
    return rawData.map((item: any) => {
      i = i + 1;
      let chegadaTransformada: string = this.excelSerialToDate(item['4']);
      let horaTransformada: string = this.excelToTime(item['5']);

      const inflatedItem: any = {
        processo: item['0'],
        fatura: item['1'],
        aeroporto: item['2'],
        partida: item['3'],
        chegada: chegadaTransformada.split('T')[0],
        hora: horaTransformada,
        rate: item['6'],
        frete: item['7'],
        hawb: item['8'],
        master: item['9'],
        Volumes: item['10'],
        ['Weight Loaded']: item['11'],
        Cubage: item['12'],
        status: item['13'],
        dataReferencia: new Date(dataAtual).toString(),
        tableName: 'fluxoAereo',
        ID: (Date.now() + i).toString(),
      };
      return inflatedItem;
    });
  }

  async getVeiculosFromDynamoDB(): Promise<void> {
    try {
      const filtro = '';
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItems(this.query3, this.urlConsultaCompleta, filtro)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });

      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculos = items.map(item => ({ ...item, checked: false }));
            // this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  sortBy(column: string) {
    if (this.sortColumn === column) {
      // Reverse the sort direction
      this.sortDirection *= -1;
    } else {
      // Set the new sort column and reset the sort direction
      this.sortColumn = column;
      this.sortDirection = 1;
    }
    // Sort the data array based on the selected column and direction
    this.jsonData.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const valueA = a[this.sortColumn];
      const valueB = b[this.sortColumn];
      if (valueA < valueB) {
        return -1 * this.sortDirection;
      } else if (valueA > valueB) {
        return 1 * this.sortDirection;
      } else {
        return 0;
      }
    });
  }

}
